<div class="modal-header">
    <h4 class="modal-title">Ret forventet på</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <div class="table__viewport">
        <table class="table table-hover table-striped table-sm table-frame__body" >
            <thead class="fixed-top position-fixed position-sticky">
                <tr>
                    <th>Dato</th>
                    <th class="text-end">Forventet tab</th>
                </tr>
            </thead>
            <tbody>
            <tr *ngFor="let forventedtab of forventedtablist$ | async;">
                <td>{{forventedtab.date | date:'dd-MM-yyyy'}}</td>
                <td class="text-end">{{forventedtab.forventetTab | currency:'DKK':'':'1.0-0':'da'}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
